import template from '../../contactsJourney/ContactsJourneyView.html';
import { ContactsJourneyController } from '../../contactsJourney/ContactsJourneyController';
const ContactsJourney = {
    template,
    controller: ContactsJourneyController,
    controllerAs: '$ctrl',
    bindings: {},
};
export default ContactsJourney;
